import type { ComicItem, ComicChapter } from './types';

const createChapters = (comicId: string, count: number): ComicChapter[] => {
  const chapters: ComicChapter[] = [];
  for (let i = count; i >= 1; i--) {
    chapters.push({
      id: `${comicId}-ch-${i}`,
      comicId,
      title: `第${i}话`,
      chapterNumber: i,
      createdAt: new Date(2026, 6, count - i + 1).toISOString().split('T')[0],
      pageCount: Math.floor(Math.random() * 20) + 25,
    });
  }
  return chapters;
};

export const comics: ComicItem[] = [
  {
    id: 'comic-1',
    title: '秘密花园',
    author: '金秀贤',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20romance%20drama%2C%20beautiful%20couple%20in%20flower%20garden%2C%20soft%20warm%20lighting%2C%20emotional%20atmosphere%2C%20delicate%20linework%2C%20pastel%20color%20palette%2C%20webtoon%20style%2C%20clean%20composition%2C%20light%20cream%20background&width=600&height=800&seq=comic-secret-garden&orientation=portrait',
    description: '一段发生在首尔江南区的浪漫爱情故事。平凡女孩林小月意外邂逅了顶级财阀继承人，两人在误会与冲突中逐渐走近彼此。当秘密揭开的那一刻，他们的爱情能否经受住考验？画风细腻唯美，剧情层层推进，让人欲罢不能。',
    categoryId: 'cat-1',
    categoryName: '恋爱',
    status: '连载中',
    rating: 9.2,
    views: 1580000,
    updatedAt: '2026-08-03',
    tags: ['恋爱', '都市', '甜宠', '财阀'],
    chapterCount: 89,
    chapters: createChapters('comic-1', 89),
    isNew: false,
    isHot: true,
  },
  {
    id: 'comic-2',
    title: '剑与魔法',
    author: '李东旭',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%2C%20warrior%20with%20glowing%20sword%2C%20magical%20effects%2C%20epic%20adventure%2C%20dramatic%20lighting%2C%20detailed%20armor%2C%20webtoon%20art%20style%2C%20cool%20color%20tones%20with%20warm%20accents%2C%20clean%20background&width=600&height=800&seq=comic-sword-magic&orientation=portrait',
    description: '在剑与魔法交织的异世界中，一位被驱逐的骑士意外获得了上古神剑，从此踏上复仇与救赎之路。宏大的世界观设定，华丽的战斗场面，以及错综复杂的势力关系，让这部作品成为奇幻类的不朽经典。',
    categoryId: 'cat-2',
    categoryName: '奇幻',
    status: '连载中',
    rating: 9.5,
    views: 2340000,
    updatedAt: '2026-08-04',
    tags: ['奇幻', '冒险', '战斗', '复仇'],
    chapterCount: 156,
    chapters: createChapters('comic-2', 156),
    isNew: false,
    isHot: true,
  },
  {
    id: 'comic-3',
    title: '深夜食堂',
    author: '朴智恩',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%2C%20cozy%20restaurant%20interior%2C%20warm%20lighting%2C%20delicious%20food%2C%20various%20characters%2C%20heartwarming%20atmosphere%2C%20webtoon%20style%2C%20soft%20warm%20colors%2C%20simple%20background&width=600&height=800&seq=comic-midnight-diner&orientation=portrait',
    description: '首尔街头一家只在深夜营业的小餐馆，每位客人都有自己的故事。老板娘用美食温暖了无数疲惫的灵魂。每一话都是一个独立而动人的故事，让人在深夜也能感受到温度。',
    categoryId: 'cat-8',
    categoryName: '日常',
    status: '连载中',
    rating: 9.3,
    views: 980000,
    updatedAt: '2026-08-02',
    tags: ['日常', '美食', '治愈', '温情'],
    chapterCount: 45,
    chapters: createChapters('comic-3', 45),
    isNew: false,
    isHot: true,
  },
  {
    id: 'comic-4',
    title: '追踪者',
    author: '崔敏浩',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20thriller%20cover%2C%20detective%20in%20dark%20alley%2C%20noir%20atmosphere%2C%20rainy%20night%2C%20suspenseful%20mood%2C%20dramatic%20shadows%2C%20webtoon%20art%20style%2C%20muted%20dark%20tones%2C%20city%20background&width=600&height=800&seq=comic-tracker&orientation=portrait',
    description: '一名刑警在追踪连环杀人案的过程中，发现自己深陷一个巨大的阴谋。每个线索都指向更高层的权力斗争。紧凑的节奏、密集的反转，让人一口气读完停不下来。',
    categoryId: 'cat-4',
    categoryName: '悬疑',
    status: '已完结',
    rating: 9.1,
    views: 1870000,
    updatedAt: '2026-07-15',
    tags: ['悬疑', '推理', '犯罪', '暗黑'],
    chapterCount: 112,
    chapters: createChapters('comic-4', 112),
    isNew: false,
    isHot: false,
  },
  {
    id: 'comic-5',
    title: '校园风云',
    author: '尹恩惠',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20life%20cover%2C%20students%20in%20uniform%2C%20youthful%20energy%2C%20bright%20sunny%20day%2C%20friendship%20theme%2C%20webtoon%20art%20style%2C%20vibrant%20warm%20colors%2C%20school%20building%20background&width=600&height=800&seq=comic-school-wind&orientation=portrait',
    description: '在一所高手云集的重点高中里，五个性格迥异的学生组成了最不被看好的社团——漫画研究社。他们从互不相识到成为一生挚友，共同经历了青春最美好的时光。',
    categoryId: 'cat-10',
    categoryName: '校园',
    status: '连载中',
    rating: 8.9,
    views: 756000,
    updatedAt: '2026-08-03',
    tags: ['校园', '青春', '友情', '成长'],
    chapterCount: 67,
    chapters: createChapters('comic-5', 67),
    isNew: true,
    isHot: false,
  },
  {
    id: 'comic-6',
    title: '搞笑一家人',
    author: '郑多彬',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cover%2C%20funny%20family%20portrait%2C%20exaggerated%20expressions%2C%20colorful%20style%2C%20humorous%20webtoon%2C%20bright%20warm%20colors%2C%20living%20room%20background%2C%20playful%20atmosphere&width=600&height=800&seq=comic-funny-family&orientation=portrait',
    description: '一家五口的爆笑日常！爸爸是典型的"直男癌"患者，妈妈是掌控全家的女王，三个孩子各有各的奇葩性格。每集都是让人捧腹大笑的日常闹剧，堪称减压神器。',
    categoryId: 'cat-5',
    categoryName: '搞笑',
    status: '连载中',
    rating: 9.0,
    views: 2120000,
    updatedAt: '2026-08-04',
    tags: ['搞笑', '家庭', '日常', '轻松'],
    chapterCount: 203,
    chapters: createChapters('comic-6', 203),
    isNew: false,
    isHot: true,
  },
  {
    id: 'comic-7',
    title: '血色公寓',
    author: '姜虎东',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20cover%2C%20creepy%20apartment%20building%2C%20dark%20atmosphere%2C%20red%20accents%2C%20mysterious%20shadow%2C%20horror%20webtoon%20style%2C%20ominous%20mood%2C%20night%20scene%2C%20clean%20dark%20background&width=600&height=800&seq=comic-blood-apartment&orientation=portrait',
    description: '搬进廉价公寓的大学生朴志勋，每晚都会听到隔壁传来的奇怪声音。当他开始调查时，发现这栋公寓隐藏着一个令人毛骨悚然的秘密。压抑的氛围营造，让人不寒而栗。',
    categoryId: 'cat-6',
    categoryName: '恐怖',
    status: '连载中',
    rating: 8.7,
    views: 645000,
    updatedAt: '2026-07-30',
    tags: ['恐怖', '惊悚', '灵异', '悬疑'],
    chapterCount: 34,
    chapters: createChapters('comic-7', 34),
    isNew: true,
    isHot: false,
  },
  {
    id: 'comic-8',
    title: '重生之逆袭人生',
    author: '宋智孝',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20isekai%20rebirth%20cover%2C%20protagonist%20in%20royal%20palace%2C%20time%20travel%20theme%2C%20dramatic%20transformation%2C%20webtoon%20art%20style%2C%20rich%20warm%20colors%2C%20elegant%20composition%2C%20palace%20interior%20background&width=600&height=800&seq=comic-rebirth-life&orientation=portrait',
    description: '事业失败、被爱人背叛的韩智浩意外重生回到十年前。带着前世的记忆，他发誓要改变一切，让所有看不起他的人刮目相看。逆袭爽文的巅峰之作，节奏极佳！',
    categoryId: 'cat-9',
    categoryName: '穿越',
    status: '连载中',
    rating: 9.4,
    views: 2890000,
    updatedAt: '2026-08-04',
    tags: ['穿越', '重生', '逆袭', '爽文'],
    chapterCount: 178,
    chapters: createChapters('comic-8', 178),
    isNew: false,
    isHot: true,
  },
  {
    id: 'comic-9',
    title: '花开彼岸',
    author: '韩佳人',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20romance%20cover%2C%20melancholic%20couple%2C%20cherry%20blossom%20scenery%2C%20emotional%20story%2C%20webtoon%20style%2C%20soft%20pink%20and%20warm%20tones%2C%20beautiful%20nature%20background%2C%20delicate%20artwork&width=600&height=800&seq=comic-flower-bloom&orientation=portrait',
    description: '两位因家庭原因被迫分离的青梅竹马，十年后在东京街头重逢。可是时间改变了太多东西，他们还能找回当初的纯真吗？一部让人泪目的爱情悲剧，情感描写极为细腻。',
    categoryId: 'cat-7',
    categoryName: '剧情',
    status: '已完结',
    rating: 9.6,
    views: 3120000,
    updatedAt: '2026-06-20',
    tags: ['剧情', '爱情', '悲剧', '治愈'],
    chapterCount: 78,
    chapters: createChapters('comic-9', 78),
    isNew: false,
    isHot: true,
  },
  {
    id: 'comic-10',
    title: '格斗传说',
    author: '权相佑',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20fight%20cover%2C%20martial%20artist%20in%20dynamic%20pose%2C%20intense%20battle%2C%20dramatic%20action%2C%20webtoon%20art%20style%2C%20bold%20warm%20colors%2C%20arena%20background%2C%20powerful%20composition&width=600&height=800&seq=comic-fight-legend&orientation=portrait',
    description: '一个从小被欺负的瘦弱少年，在神秘教练的指导下踏上了格斗之路。从街头斗殴到职业赛场，他用拳头打出了自己的传奇。打斗分镜堪称教科书级别，热血浓度爆表。',
    categoryId: 'cat-3',
    categoryName: '动作',
    status: '连载中',
    rating: 9.3,
    views: 1750000,
    updatedAt: '2026-08-03',
    tags: ['动作', '格斗', '热血', '成长'],
    chapterCount: 134,
    chapters: createChapters('comic-10', 134),
    isNew: false,
    isHot: true,
  },
  {
    id: 'comic-11',
    title: '我的契约恋人',
    author: '孙艺珍',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%2C%20elegant%20couple%20in%20formal%20wear%2C%20contract%20marriage%20theme%2C%20luxury%20setting%2C%20webtoon%20style%2C%20warm%20golden%20accents%2C%20mansion%20background%2C%20romantic%20atmosphere&width=600&height=800&seq=comic-contract-lover&orientation=portrait',
    description: '为了挽救家族企业，女主角被迫与冷漠总裁签订契约恋爱。本以为是场交易，却在不经意间动了真心。高甜预警，契约恋爱变真爱的经典之作！',
    categoryId: 'cat-1',
    categoryName: '恋爱',
    status: '连载中',
    rating: 8.8,
    views: 1320000,
    updatedAt: '2026-08-01',
    tags: ['恋爱', '契约', '总裁', '甜宠'],
    chapterCount: 56,
    chapters: createChapters('comic-11', 56),
    isNew: true,
    isHot: false,
  },
  {
    id: 'comic-12',
    title: '异世界药神',
    author: '金来沅',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20isekai%20cover%2C%20apothecary%20in%20medieval%20setting%2C%20magical%20potions%2C%20herbs%20and%20bottles%2C%20webtoon%20style%2C%20warm%20earthy%20tones%2C%20wooden%20shop%20background%2C%20mystical%20atmosphere&width=600&height=800&seq=comic-isekai-pharma&orientation=portrait',
    description: '现代药剂师穿越到剑与魔法的世界，凭借现代医药知识成为异世界的药神。没有战斗力？没关系，一瓶药水可以让巨龙俯首称臣。另类穿越，知识就是力量！',
    categoryId: 'cat-9',
    categoryName: '穿越',
    status: '连载中',
    rating: 9.1,
    views: 1450000,
    updatedAt: '2026-08-02',
    tags: ['穿越', '奇幻', '制药', '冒险'],
    chapterCount: 98,
    chapters: createChapters('comic-12', 98),
    isNew: false,
    isHot: true,
  },
  {
    id: 'comic-13',
    title: '学霸的秘密',
    author: '刘在石',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20mystery%20cover%2C%20students%20in%20library%2C%20secret%20note%2C%20intrigue%20theme%2C%20webtoon%20style%2C%20warm%20brown%20tones%2C%20school%20library%20background%2C%20suspenseful%20atmosphere&width=600&height=800&seq=comic-smart-student&orientation=portrait',
    description: '全校第一名的学霸突然失踪，留下的笔记中记载了令人震惊的真相。几个同班同学联手调查，发现这所学校背后隐藏着不可告人的秘密。校园悬疑佳作！',
    categoryId: 'cat-4',
    categoryName: '悬疑',
    status: '连载中',
    rating: 8.6,
    views: 567000,
    updatedAt: '2026-07-28',
    tags: ['悬疑', '校园', '推理', '青春'],
    chapterCount: 41,
    chapters: createChapters('comic-13', 41),
    isNew: true,
    isHot: false,
  },
  {
    id: 'comic-14',
    title: '猫咪咖啡厅',
    author: '李宝英',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%2C%20cute%20cat%20cafe%2C%20cozy%20interior%2C%20adorable%20cats%2C%20heartwarming%2C%20webtoon%20style%2C%20soft%20warm%20pastel%20colors%2C%20cafe%20background%2C%20peaceful%20atmosphere&width=600&height=800&seq=comic-cat-cafe&orientation=portrait',
    description: '厌倦职场生活的女主角辞职后开了一家猫咪咖啡厅，在这里遇到了各种各样的客人和可爱的小猫咪。温馨治愈的日常，每一页都让人感到幸福。',
    categoryId: 'cat-8',
    categoryName: '日常',
    status: '连载中',
    rating: 8.5,
    views: 423000,
    updatedAt: '2026-08-01',
    tags: ['日常', '治愈', '猫咪', '美食'],
    chapterCount: 28,
    chapters: createChapters('comic-14', 28),
    isNew: true,
    isHot: false,
  },
  {
    id: 'comic-15',
    title: '鬼怪传说',
    author: '裴勇俊',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20supernatural%20horror%20cover%2C%20ancient%20Korean%20ghost%2C%20traditional%20hanbok%2C%20dark%20forest%2C%20supernatural%20theme%2C%20webtoon%20style%2C%20dark%20with%20red%20accents%2C%20night%20mountain%20background%2C%20eerie%20atmosphere&width=600&height=800&seq=comic-ghost-legend&orientation=portrait',
    description: '以韩国传统民间传说为蓝本，讲述了一群驱魔师对抗恶鬼的故事。融合了韩国传统文化与现代叙事手法，想象力惊人，画风独树一帜。',
    categoryId: 'cat-6',
    categoryName: '恐怖',
    status: '已完结',
    rating: 9.0,
    views: 890000,
    updatedAt: '2026-05-30',
    tags: ['恐怖', '灵异', '传统文化', '驱魔'],
    chapterCount: 64,
    chapters: createChapters('comic-15', 64),
    isNew: false,
    isHot: false,
  },
  {
    id: 'comic-16',
    title: '武林至尊',
    author: '金钟国',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20cover%2C%20warrior%20in%20ancient%20China%20setting%2C%20epic%20battle%20scene%2C%20dynamic%20action%2C%20webtoon%20style%2C%20bold%20warm%20red%20accents%2C%20mountain%20temple%20background%2C%20powerful%20composition&width=600&height=800&seq=comic-martial-arts&orientation=portrait',
    description: '在强者为尊的武林世界中，一个被灭门的少年带着唯一的武功秘籍踏上了复仇之路。拳拳到肉的战斗、令人血脉偾张的比武大会，武侠迷不可错过的热血大作。',
    categoryId: 'cat-3',
    categoryName: '动作',
    status: '连载中',
    rating: 9.4,
    views: 2010000,
    updatedAt: '2026-08-04',
    tags: ['动作', '武侠', '复仇', '热血'],
    chapterCount: 145,
    chapters: createChapters('comic-16', 145),
    isNew: false,
    isHot: true,
  },
  {
    id: 'comic-17',
    title: '恋爱必修课',
    author: '河智苑',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20campus%20romance%20cover%2C%20college%20couple%2C%20autumn%20campus%2C%20sweet%20romance%2C%20webtoon%20style%2C%20warm%20orange%20tones%2C%20university%20background%2C%20youthful%20atmosphere&width=600&height=800&seq=comic-love-course&orientation=portrait',
    description: '大学新生的恋爱物语！四个来自不同专业的女生，在美好的大学时光中各自遇到了命中注定的那个人。友情与爱情交织，青春最美的模样。',
    categoryId: 'cat-10',
    categoryName: '校园',
    status: '连载中',
    rating: 8.7,
    views: 1020000,
    updatedAt: '2026-08-03',
    tags: ['校园', '恋爱', '友情', '大学'],
    chapterCount: 72,
    chapters: createChapters('comic-17', 72),
    isNew: false,
    isHot: false,
  },
  {
    id: 'comic-18',
    title: '爆笑便利店',
    author: '车太贤',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cover%2C%20convenience%20store%20setting%2C%20funny%20customers%2C%20exaggerated%20expressions%2C%20humorous%2C%20webtoon%20style%2C%20bright%20warm%20colors%2C%20store%20interior%20background%2C%20playful%20atmosphere&width=600&height=800&seq=comic-funny-store&orientation=portrait',
    description: '在24小时便利店里发生的各种奇葩事件！神经质店长、迷糊兼职生、奇葩顾客，每天都是鸡飞狗跳的欢乐日常。笑点密集，轻松减压的不二之选。',
    categoryId: 'cat-5',
    categoryName: '搞笑',
    status: '连载中',
    rating: 8.4,
    views: 890000,
    updatedAt: '2026-07-31',
    tags: ['搞笑', '日常', '职场', '轻松'],
    chapterCount: 120,
    chapters: createChapters('comic-18', 120),
    isNew: false,
    isHot: false,
  },
  {
    id: 'comic-19',
    title: '女王陛下',
    author: '全智贤',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20drama%20cover%2C%20queen%20in%20royal%20palace%2C%20historical%20Korean%20setting%2C%20political%20intrigue%2C%20webtoon%20style%2C%20rich%20warm%20gold%20accents%2C%20throne%20room%20background%2C%20elegant%20composition&width=600&height=800&seq=comic-queen-majesty&orientation=portrait',
    description: '以朝鲜王朝为背景，讲述了一位宫女如何凭借智慧与勇气一步步走向王座。宫廷权谋、爱恨情仇，大气磅礴的历史正剧，女性力量的最好诠释。',
    categoryId: 'cat-7',
    categoryName: '剧情',
    status: '连载中',
    rating: 9.5,
    views: 2670000,
    updatedAt: '2026-08-04',
    tags: ['剧情', '历史', '宫斗', '女性'],
    chapterCount: 92,
    chapters: createChapters('comic-19', 92),
    isNew: false,
    isHot: true,
  },
  {
    id: 'comic-20',
    title: '恶魔角',
    author: '玄彬',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20dark%20fantasy%20cover%2C%20demon%20hunter%2C%20gothic%20style%2C%20supernatural%20battle%2C%20dark%20fantasy%2C%20webtoon%20style%2C%20dark%20with%20warm%20fire%20accents%2C%20underworld%20background%2C%20epic%20atmosphere&width=600&height=800&seq=comic-demon-horn&orientation=portrait',
    description: '当一个普通人头上长出了恶魔的角，他的人生彻底改变。天堂与地狱的战争降临人间，而他就是关键。黑暗奇幻的巅峰之作，情节宏大，设定新颖。',
    categoryId: 'cat-2',
    categoryName: '奇幻',
    status: '连载中',
    rating: 9.2,
    views: 1560000,
    updatedAt: '2026-08-03',
    tags: ['奇幻', '黑暗', '战斗', '神话'],
    chapterCount: 87,
    chapters: createChapters('comic-20', 87),
    isNew: false,
    isHot: true,
  },
];